// @ts-nocheck
import { getAccount, updateAccount } from "@insite/client-framework/Services/AccountService";
import translate from "@insite/client-framework/Translate";
import { Select } from "@insite/mobius/index";
import useCanSeePrices from "@store/Framework/Store/Data/Accounts/Hooks/useCanSeePrices";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import React from "react";
import styled, { css } from "styled-components";

const StyledSelect = styled(Select)`
    width: 50%;
`;

const overridePricePolicySelect: React.FC = () => {
    const canSeePrices = useCanSeePrices();

    const handlePricePolicyChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
        const canSeePrices = event.target.value;
        const account = await getAccount({} as any);

        await updateAccount({
            account: {
                ...account,
                properties: {
                    canSeePricesPolicy: canSeePrices,
                },
            },
        } as any);
    };

    return (
        <>
            <StyledSelect
                // key is needed to force a re-mount so that the initial value is accurate.  Component can't be controlled as updating account doesn't update the store.
                key={canSeePrices.toString()}
                cssOverrides={{
                    formField: css`
                        margin-left: 1rem;
                    `,
                    formInputWrapper: css`
                        width: 50%;
                    `,
                }}
                label="Show Prices"
                defaultValue={canSeePrices.toString()}
                onChange={handlePricePolicyChange}
            >
                <option value="true">{translate("Show Prices")}</option>
                <option value="false">{translate("Hide Prices")}</option>
            </StyledSelect>
        </>
    );
};
const widgetModule: CustomWidgetModule = {
    component: overridePricePolicySelect,
    definition: {
        group: "SignaturePad",
        displayName: "OverridePricePolicySelect",
    },
};

export default widgetModule;
